import { useGetUserProfileQuery } from '../../../api/combined'
import { GetBookmarksQueryParams, useGetBookmarksQuery } from '../../../api/core'

export const useBookmarks = (isPublic: boolean = true) => {
  const { data: currentUser } = useGetUserProfileQuery()
  return useGetBookmarksQuery({ userEmail: currentUser?.email, isPublic } as GetBookmarksQueryParams)
}
